import React from 'react'
import styled from 'styled-components'
import { Wrapper } from '@farewill/ui'
import { COLOR } from '@farewill/ui/tokens'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'

const StyledLockupWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 22px;
`

/*
 * The BHF logo has a transparent background, so it needs a white box to be
 * legible on the yellow header.
 */
const StyledBHFLogo = styled.img`
  display: block;
  box-sizing: border-box;
  height: 45px;
  padding: 8px 12px;
  background: ${COLOR.WHITE};
`

const BHFXFarewillLogo = () => (
  <StyledLockupWrapper noTrim>
    <a
      aria-label="Visit British Heart Foundation homepage"
      href="https://www.bhf.org.uk/"
    >
      <StyledBHFLogo
        alt="British Heart Foundation"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/bhf/logo.svg`}
      />
    </a>
    <a aria-label="Visit Farewill's homepage" href="https://farewill.com">
      <img
        alt="Farewill"
        height="40"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/x-Farewill.svg`}
      />
    </a>
  </StyledLockupWrapper>
)

export default BHFXFarewillLogo
